import './merchants.css';
import 'firebase/functions';

import { AvField, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { database, functions } from 'firebase';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Button, Col, Container, FormGroup, Label } from 'reactstrap';
import Loader from 'components/loader/loader';
import ButtonWithLoader from 'components/buttonWithLoader/buttonWithLoader';

class Merchant extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      email: null,

      businessName: null,
      businessAddress: null,
      businessTown: null,
      businessState: null,
      companyNumber: null,
      companyNumberValid: false,

      iban1: null,
      iban2: null,
      ibanMatch: null,
      bankCountry: "IE",
      bankAccountCurrency: "EUR",

      userFName: null,
      userLName: null,
      userAddress: null,
      userTown: null,
      userState: null,
      userDay: null,
      userDayValid: null,
      userMonth: null,
      userMonthValid: null,
      userYear: null,
      userYearValid: null,

      submitted: false,
      owner1: {},
      owner2: {},
      owner3: {},
      owner4: {},

      businessType: "company",
      isSoleTrader: false,

      termsCheckbox: "false",
      isSubmitting: false,

      isLoading: true,
    }

    this.handleChildChange = this.handleChildChange.bind(this)
    this.handler = this.handler.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  async componentDidMount() {
    document.title = "Payouts Signup - Bamboo";

    this.getExistingDetails();
  }

  async componentDidUpdate() {
    if (this.state.isLoading === false && this.state.submitted === false) {
      await this.saveDataToDatabase();
    }
  }

  async getExistingDetails() {
    if (this.context.authUser) {
      const merchantUserId = this.context.userId;

      try {
        let snapshot = await database().ref('customMerchants/' + merchantUserId).once('value');

        let submitted = false;

        if (snapshot.val()) {
          submitted = _.get(snapshot.val(), "submitted", false);

          if (submitted === false) {

            // need to set this so correct signup UI is displayed
            let businessType = _.get(snapshot.val(), 'businessType', null);
            const isSoleTrader = (businessType === "individual");

            this.setState({
              email: _.get(snapshot.val(), 'email', null),
              emailValid: _.has(snapshot.val(), 'email'),
              businessName: _.get(snapshot.val(), 'businessName', null),
              businessAddress: _.get(snapshot.val(), 'businessAddress', null),
              businessTown: _.get(snapshot.val(), 'businessTown', null),
              businessState: _.get(snapshot.val(), 'businessState', null),
              businessType: businessType,
              isSoleTrader: isSoleTrader,
              iban1: _.get(snapshot.val(), 'iban', null),
              companyNumber: _.get(snapshot.val(), 'companyNumber', null),
              companyNumberValid: _.has(snapshot.val(), 'companyNumber'),
              userFName: _.get(snapshot.val(), 'businessRep.firstName', null),
              userLName: _.get(snapshot.val(), 'businessRep.lastName', null),
              userAddress: _.get(snapshot.val(), 'businessRep.address.line1', null),
              userTown: _.get(snapshot.val(), 'businessRep.address.city', null),
              userState: _.get(snapshot.val(), 'businessRep.address.state', null),
              userDay: _.get(snapshot.val(), 'businessRep.dob.day', null),
              userDayValid: _.has(snapshot.val(), 'businessRep.dob.day'),
              userMonth: _.get(snapshot.val(), 'businessRep.dob.month', null),
              userMonthValid: _.has(snapshot.val(), 'businessRep.dob.month'),
              userYear: _.get(snapshot.val(), 'businessRep.dob.year', null),
              userYearValid: _.has(snapshot.val(), 'businessRep.dob.year'),
              owner1: _.get(snapshot.val(), 'additionalOwners[0]', {}),
              owner2: _.get(snapshot.val(), 'additionalOwners[1]', {}),
              owner3: _.get(snapshot.val(), 'additionalOwners[2]', {}),
              owner4: _.get(snapshot.val(), 'additionalOwners[3]', {}),
              isLoading: false,
            });
          } else {
            this.setState({ isLoading: false, submitted: true });
          }
        } else {
          this.setState({ isLoading: false });
        }
      } catch (e) {
        console.log(e);
        this.setState({ isLoading: false });
      }
    } else {
      this.setState({ isLoading: false });
    }
  }

  handler = (event) => {
    const state = { [event.target.name]: event.target.value };
    this.setState(state);

    // handle additional specifics 
    if (event.target.name === "businessType") {
      if (event.target.value === "individual")
        this.setState({ isSoleTrader: true });
      else
        this.setState({ isSoleTrader: false });
    }
  }

  handleChildChange = (event) => {
    const nameSeperated = event.target.name.split("-");
    const ownerKey = nameSeperated[0];
    const fieldKey = nameSeperated[1];

    // update owner object
    const owner = this.state[ownerKey];
    if (owner) {
      owner[fieldKey] = event.target.value;
      this.setState({ [ownerKey]: owner });
    }
  }

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
    const email = event.target.value;

    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (email !== '' && regex.test(String(email)))
      this.setState({ emailValid: true });
    else
      this.setState({ emailValid: false });
  }

  handleIban1Change = (event) => {
    this.setState({ iban1: event.target.value });

    const iban2 = this.state.iban2;

    if (iban2 === event.target.value)
      this.setState({ ibanMatch: true })
    else
      this.setState({ ibanMatch: false })
  }

  handleIban2Change = (event) => {
    this.setState({ iban2: event.target.value });

    const iban1 = this.state.iban1;

    if (iban1 === event.target.value)
      this.setState({ ibanMatch: true })
    else
      this.setState({ ibanMatch: false })
  }

  handleDayChange = (event) => {
    const day = event.target.value;

    if (day > 0 && day < 32 && !isNaN(day)) {
      this.setState({ userDay: day });
      this.setState({ userDayValid: true });
    } else {
      this.setState({ userDayValid: false });
    }
  }

  handleMonthChange = (event) => {
    const month = event.target.value;

    if (month > 0 && month < 13 && !isNaN(month)) {
      this.setState({ userMonth: month });
      this.setState({ userMonthValid: true });
    } else {
      this.setState({ userMonthValid: false });
    }
  }

  handleYearChange = (event) => {
    const year = event.target.value;

    if (year > 1920 && year < (new Date().getFullYear()) && !isNaN(year)) {
      this.setState({ userYear: year });
      this.setState({ userYearValid: true });
    } else {
      this.setState({ userYearValid: false });
    }
  }

  handleCompanyNumberChange = (event) => {
    const companyNumber = event.target.value;

    if (companyNumber.length >= 6) {
      this.setState({ companyNumber: companyNumber });
      this.setState({ companyNumberValid: true });
    } else {
      this.setState({ companyNumberValid: false });
    }
  }

  getAdditionalOwners() {
    let owners = [];
    let formOwners = [];

    formOwners.push(this.state.owner1);
    formOwners.push(this.state.owner2);
    formOwners.push(this.state.owner3);
    formOwners.push(this.state.owner4);

    formOwners.forEach(formOwner => {
      let owner = {};
      owner.firstName = _.get(formOwner, "firstName", null);
      owner.lastName = _.get(formOwner, "lastName", null);

      owner.dob = {
        day: _.get(formOwner, "day", null),
        month: _.get(formOwner, "month", null),
        year: _.get(formOwner, "year", null),
      };

      owner.address = {
        line1: _.get(formOwner, "line1", null),
        city: _.get(formOwner, "city", null),
        state: _.get(formOwner, "state", null),
        country: "IE"
      };

      let ownerNameValid = _.isString(owner.firstName) && _.isString(owner.lastName);
      let ownerDobValid = _.includes(owner.dob, null) === false && _.includes(owner.dob, "") === false;
      let ownerAddressValid = _.includes(owner.address, null) === false && _.includes(owner.address, "") === false;

      if (ownerNameValid && ownerDobValid && ownerAddressValid) {
        owners.push(owner);
      }

    });

    return owners;
  }

  validateForm() {
    let errors = [];

    let isSoleTraderWithoutNumber = this.state.isSoleTrader && _.isEmpty(this.state.companyNumber);
    let hasValidCompanyNumber = this.state.companyNumberValid;

    if (isSoleTraderWithoutNumber === false && hasValidCompanyNumber === false) {
      errors.push("Company number is not valid");
    }

    if (!this.state.ibanMatch) {
      errors.push("IBANs do not match");
    }

    if (!this.state.emailValid) {
      errors.push("Email is not valid");
    }

    if (!this.state.userDayValid || !this.state.userMonthValid || !this.state.userYearValid) {
      errors.push("Business representative date of birth is not valid");
    }

    // if not sole trader, check additional owner(s)
    if (!this.state.isSoleTrader) {
      let owners = this.getAdditionalOwners();

      owners.forEach(owner => {
        if (!owner.firstName) {
          errors.push("An owner is missing a first name");
        }
        if (!owner.lastName) {
          errors.push("An owner is missing a last name");
        }
        if (!owner.dob.day) {
          errors.push("An owner is missing the day of their dob");
        }
        if (!owner.dob.month) {
          errors.push("An owner is missing the month of their dob");
        }
        if (!owner.dob.year) {
          errors.push("OAn owner is missing the year of their dob");
        }
        if (!owner.address || !owner.address.city || !owner.address.line1) {
          errors.push("An owner is missing part of their address");
        }
      });
    }

    return errors;
  }

  async saveDataToDatabase(tosAcceptance = null) {
    let additionalOwners = this.getAdditionalOwners();

    const dataPayload = {
      merchantUserId: this.context.userId,
      email: this.state.email,
      businessType: this.state.businessType,
      businessName: this.state.businessName,
      businessAddress: this.state.businessAddress,
      businessTown: this.state.businessTown,
      businessState: this.state.businessState,
      companyNumber: this.state.companyNumber,
      iban: this.state.iban1,
      bankCountry: this.state.bankCountry,
      bankAccountCurrency: this.state.bankAccountCurrency,
      businessRep: {
        firstName: this.state.userFName,
        lastName: this.state.userLName,
        address: {
          line1: this.state.userAddress,
          city: this.state.userTown,
          state: this.state.userState,
          country: "IE"
        },
        dob: {
          day: this.state.userDay,
          month: this.state.userMonth,
          year: this.state.userYear
        }
      },
      additionalOwners: additionalOwners
    };

    if (tosAcceptance) {
      dataPayload.tosAcceptance = tosAcceptance
    }

    try {
      await database().ref('customMerchants/' + this.context.userId).update(dataPayload);
    } catch (e) {
      console.error(e);
    }
  }

  async handleValidSubmit(event) {
    this.setState({ isSubmitting: true });
    let errors = this.validateForm();

    if (errors.length > 0) {
      let errorMsg = "Errors in form: \n\n";
      let numErrors = 1;

      errors.forEach(error => {
        errorMsg += (numErrors + ": " + error + "\n");
        numErrors++;
      });

      if (numErrors > 1)
        errorMsg += "\nPlease fix the above issues and re-submit";
      else
        errorMsg += "\nPlease fix the above issue and re-submit";

      alert(errorMsg);
      this.setState({ isSubmitting: false });
      return;
    }

    // get time for tos
    const acceptanceDate = Math.floor(Date.now() / 1000);

    // get user agent for tos
    const acceptingUserAgent = navigator.userAgent;

    // get IP address of client
    let ip = null;
    try {
      const res = await fetch('https://ipapi.co/json/');
      const resJson = await res.json()
      ip = resJson.ip;
    } catch (e) {
      this.setState({ isSubmitting: false });
      alert("Failed to get your IP address required for Terms of Service acceptance. Please try again or contact support.");
      console.error(e);
    }

    const acceptingIpAddress = ip;

    await this.saveDataToDatabase({
      date: acceptanceDate,
      userAgent: acceptingUserAgent,
      ip: acceptingIpAddress
    });

    const createConnectAccount = functions().httpsCallable('createConnectAccount');

    try {
      await createConnectAccount();
      this.setState({ submitted: true });
    } catch (error) {
      this.setState({ isSubmitting: false });
      console.error(error);
      alert(`Something went wrong. Please try again or contact support. (${error.message})`);
    }
  }

  render() {
    let additionalOwners = (
      <div className="form-section">
        <h5>All other individuals who own more than 25% of the company (optional)</h5>
        <p>Please list all other individuals who own more than 25% of the company, or are in a position to exercise significant control of the company’s finances and operations. Examples of individuals who exercise significant control may be chief operating officers or financial officers.</p>
        <OwnerForm id={1} additionalOwner={_.get(this.state, "owner1", {})} handler={this.handleChildChange} />
        <OwnerForm id={2} additionalOwner={_.get(this.state, "owner2", {})} handler={this.handleChildChange} />
        <OwnerForm id={3} additionalOwner={_.get(this.state, "owner3", {})} handler={this.handleChildChange} />
        <OwnerForm id={4} additionalOwner={_.get(this.state, "owner4", {})} handler={this.handleChildChange} />
        <hr />
      </div>
    );

    let optionalCompanyNo = (
      <AvGroup row>
        <Label sm={3}>Company number:</Label>
        <Col sm={9}>
          <AvField name="companyNo" type="text" value={this.state.companyNumber ? this.state.companyNumber : ""}
            onChange={this.handleCompanyNumberChange} placeholder="123456" helpMessage="(Optional)" />
        </Col>
      </AvGroup>
    );

    let manditoryCompanyNo = (
      <AvGroup row>
        <Label sm={3}>Company number:</Label>
        <Col sm={9}>
          <AvField name="companyNo" type="text" value={this.state.companyNumber ? this.state.companyNumber : ""}
            onChange={this.handleCompanyNumberChange} placeholder="123456" errorMessage="Required" required />
          <p>Don't have one yet? <a href="https://www.cro.ie/E-Filing/Registering-a-Business-Name-Online" target="_blank" rel="noopener noreferrer">Apply online</a></p>
        </Col>
      </AvGroup>
    );

    const signUpForm = (
      <Col md={{ size: 6, offset: 3 }} className="signup-form">
        <AvForm onValidSubmit={this.handleValidSubmit}>
          <div className="form-section">
            <h5>Business details</h5>

            <AvGroup row >
              <Label sm={3}>Business type:</Label>
              <Col sm={6}>
                <AvField name="businessType" type="select" onChange={this.handler} value={this.state.businessType ? this.state.businessType : ""}>
                  <option value="company">Limited Company</option>
                  <option value="partnership">Partnership</option>
                  <option value="individual">Individual / Sole Trader</option>
                </AvField>
              </Col>
            </AvGroup>

            <AvGroup row>
              <Label sm={3}>Email:</Label>
              <Col sm={9}>
                <AvField name="email" type="email" value={this.state.email ? this.state.email : ""} valid={this.state.emailValid}
                  invalid={this.state.emailValid !== undefined && !this.state.emailValid} onChange={this.handleEmailChange} placeholder="name@example.com" helpMessage="We may send you emails about your business from time to time" errorMessage="Required, valid email address" required />
              </Col>
            </AvGroup>

            <AvGroup row>
              <Label sm={3}>Business name:</Label>
              <Col sm={9}>
                <AvField name="businessName" onChange={this.handler} type="text" value={this.state.businessName ? this.state.businessName : ""}
                  placeholder="Company Ltd" helpMessage="Your business' legal name" errorMessage="Required" required />
              </Col>
            </AvGroup>

            <AvGroup row>
              <Label sm={3}>Business address:</Label>
              <Col sm={8}>
                <AvField name="businessAddress" type="text" value={this.state.businessAddress ? this.state.businessAddress : ""}
                  onChange={this.handler} placeholder="123 O'Connell St" errorMessage="Required" required />
              </Col>
              <Col sm={{ size: 4, offset: 3 }}>
                <AvField name="businessTown" type="text" value={this.state.businessTown ? this.state.businessTown : ""}
                  onChange={this.handler} placeholder="City / Town" errorMessage="Required" required />
              </Col>
              <Col sm={{ size: 4, offset: 0 }}>
                <AvField name="businessState" type="select" value={this.state.businessState ? this.state.businessState : ""}
                  onChange={this.handler}>
                  <option value="">Please select a county</option>
                  <option value="antrim">Antrim</option>
                  <option value="armagh">Armagh</option>
                  <option value="carlow">Carlow</option>
                  <option value="cavan">Cavan</option>
                  <option value="clare">Clare</option>
                  <option value="clare">Cork</option>
                  <option value="derry">Derry</option>
                  <option value="donegal">Donegal</option>
                  <option value="down">Down</option>
                  <option value="dublin">Dublin</option>
                  <option value="fermanagh">Fermanagh</option>
                  <option value="galway">Galway</option>
                  <option value="kerry">Kerry</option>
                  <option value="kildare">Kildare</option>
                  <option value="kilkenny">Kilkenny</option>
                  <option value="laois">Laois</option>
                  <option value="leitrim">Leitrim</option>
                  <option value="limerick">Limerick</option>
                  <option value="longford">Longford</option>
                  <option value="louth">Louth</option>
                  <option value="mayo">Mayo</option>
                  <option value="meath">Meath</option>
                  <option value="monaghan">Monaghan</option>
                  <option value="offaly">Offaly</option>
                  <option value="roscommon">Roscommon</option>
                  <option value="sligo">Sligo</option>
                  <option value="tipperary">Tipperary</option>
                  <option value="tyrone">Tyrone</option>
                  <option value="waterford">Waterford</option>
                  <option value="westmeath">Westmeath</option>
                  <option value="wexford">Wexford</option>
                  <option value="wicklow">Wicklow</option>
                </AvField>
              </Col>

            </AvGroup>

            {this.state.isSoleTrader
              ? optionalCompanyNo
              : manditoryCompanyNo
            }
          </div>

          <hr />

          <div className="form-section">
            <h5>Banking details</h5>

            <AvGroup row>
              <Label for="bankAccountCountry" sm={3}>Bank country:</Label>
              <Col sm={3}>
                <AvField name="bankAccountCountry" type="select" onChange={this.handler}>
                  <option value="IE">Ireland</option>
                </AvField>
              </Col>
            </AvGroup>

            <AvGroup row>
              <Label sm={3}>Bank account currency:</Label>
              <Col sm={3}>
                <AvField name="bankAccountCurrency" type="select" onChange={this.handler}>
                  <option value="EUR">Euro (€)</option>
                </AvField>
              </Col>
            </AvGroup>

            <AvGroup row>
              <Label for="iban" sm={3}>IBAN:</Label>
              <Col sm={9}>
                <AvField name="iban1" type="text" value={this.state.iban1 ? this.state.iban1 : ""} valid={this.state.ibanMatch} onChange={this.handleIban1Change} maxLength="34" placeholder="IE29AIBK93115212345678" errorMessage="Required" required />
              </Col>
            </AvGroup>

            <AvGroup row>
              <Label for="confirm_iban" sm={3}>Confirm IBAN:</Label>
              <Col sm={9}>
                <AvField name="iban2" type="text" valid={this.state.ibanMatch} onChange={this.handleIban2Change} maxLength="34" errorMessage="Required, must match the above" placeholder="IE29AIBK93115212345678" required />
              </Col>
            </AvGroup>
          </div>

          <hr />

          <div className="form-section">
            <h5>Business representative details</h5>

            <AvGroup row>
              <Label for="owner_1_firstName" sm={3}>Legal name:</Label>
              <Col sm={4}>
                <AvField name="userFName" type="text" value={this.state.userFName} onChange={this.handler} placeholder="First" errorMessage="Required" required />
              </Col>
              <Col sm={4}>
                <AvField name="userLName" type="text" value={this.state.userLName} onChange={this.handler} placeholder="Last" errorMessage="Required" required />
              </Col>
            </AvGroup>

            <AvGroup row>
              <Label for="owner_1_date_of_birth" sm={3}>Date of birth:</Label>
              <Col sm={2}>
                <AvField name="day" type="text" maxLength="2" value={this.state.userDay} valid={this.state.userDayValid} onChange={this.handleDayChange} placeholder="Day" errorMessage="Enter a number between 1 and 31" required />
              </Col>
              <Col sm={2}>
                <AvField name="month" type="text" maxLength="2" value={this.state.userMonth} valid={this.state.userMonthValid} onChange={this.handleMonthChange} placeholder="Month" errorMessage="Enter a number between 1 and 12" required />
              </Col>
              <Col sm={2}>
                <AvField name="year" type="text" maxLength="4" value={this.state.userYear} valid={this.state.userYearValid} onChange={this.handleYearChange} placeholder="Year" errorMessage="Enter your birth year" required />
              </Col>
            </AvGroup>

            <AvGroup row>
              <Label for="owner_1_address" sm={3}>Address:</Label>
              <Col sm={8}>
                <AvField name="userAddress" type="text" value={this.state.userAddress} placeholder="123 Pearse St" errorMessage="Required" onChange={this.handler} required />
              </Col>
              <Col sm={{ size: 4, offset: 3 }}>
                <AvField name="userTown" type="text" value={this.state.userTown} placeholder="City / town" errorMessage="Required" onChange={this.handler} required />
              </Col>
              <Col sm={{ size: 4, offset: 0 }}>
                <AvField name="userState" type="select" value={this.state.userState} onChange={this.handler}>
                  <option value="">Please select a county</option>
                  <option value="antrim">Antrim</option>
                  <option value="armagh">Armagh</option>
                  <option value="carlow">Carlow</option>
                  <option value="cavan">Cavan</option>
                  <option value="clare">Clare</option>
                  <option value="clare">Cork</option>
                  <option value="derry">Derry</option>
                  <option value="donegal">Donegal</option>
                  <option value="down">Down</option>
                  <option value="dublin">Dublin</option>
                  <option value="fermanagh">Fermanagh</option>
                  <option value="galway">Galway</option>
                  <option value="kerry">Kerry</option>
                  <option value="kildare">Kildare</option>
                  <option value="kilkenny">Kilkenny</option>
                  <option value="laois">Laois</option>
                  <option value="leitrim">Leitrim</option>
                  <option value="limerick">Limerick</option>
                  <option value="longford">Longford</option>
                  <option value="louth">Louth</option>
                  <option value="mayo">Mayo</option>
                  <option value="meath">Meath</option>
                  <option value="monaghan">Monaghan</option>
                  <option value="offaly">Offaly</option>
                  <option value="roscommon">Roscommon</option>
                  <option value="sligo">Sligo</option>
                  <option value="tipperary">Tipperary</option>
                  <option value="tyrone">Tyrone</option>
                  <option value="waterford">Waterford</option>
                  <option value="westmeath">Westmeath</option>
                  <option value="wexford">Wexford</option>
                  <option value="wicklow">Wicklow</option>
                </AvField>
              </Col>
            </AvGroup>
          </div>

          <hr />

          {
            !this.state.isSoleTrader
              ? additionalOwners
              : ''
          }


          {
            this.state.isSubmitting
              ?
              <Loader
                loading={this.state.isSubmitting}
                loaderStyle="text-center"
              />
              :
              <FormGroup className="text-center">
                <AvGroup check>
                  <Label check for="termsCheckbox" className="terms-text text-left">
                    {/* trueValue and falseValue are indeed inverted - stupid component has inverted logic on checked */}
                    <AvInput type="checkbox" onChange={this.handler} name="termsCheckbox" trueValue={false} falseValue={true} />
                    I have read and agree to the <a href="https://bambooapp.ie/merchant-terms-conditions/" target="_blank" rel="noopener noreferrer">Services Agreement</a>, <a href="https://bambooapp.ie/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>, and <a href="https://stripe.com/docs/connect/updating-accounts#tos-acceptance" target="_blank" rel="noopener noreferrer">Stripe Connected Account Agreement</a>.
                    </Label>
                </AvGroup>

                <br />

                {
                  this.state.termsCheckbox === "true"
                    ?
                    <ButtonWithLoader
                      loading={this.state.isSubmitting}
                      buttonText="Register merchant account"
                    />
                    :
                    <div>
                      <p className="terms-confirm-text terms-text">Please confirm you've read and accept the Services Agreement, Privacy Policy, and Stripe Connect Account Agreement</p>
                      <Button color="primary" className="btn-rounded" disabled>Register merchant account</Button>
                    </div>
                }
              </FormGroup>
          }
        </AvForm>
      </Col>
    );

    const loadingUI = (
      <div className="text-center">
        <Loader loading={this.state.isLoading} />
      </div>
    );

    return (
      <Container className="merchants">
        {
          this.context.isLoading === false && _.isNil(this.context.authUser)
            ? <Redirect to="/merchant/login" />
            : ""
        }

        {this.state.submitted
          ? <Redirect to="/merchant/success" />
          : ""
        }

        <Col md={{ size: 6, offset: 3 }} className="signup-form">
          <h2 className="text-center pt-3">Set up payouts</h2>
          <hr />
          <p>
            Please fill out the form below, it will only take a minute and from then on we’ll make payouts to your chosen bank every Monday.
            </p>
        </Col>

        {
          this.state.isLoading
            ? loadingUI
            : signUpForm
        }

      </Container>
    );
  }
}

Merchant.contextTypes = {
  authUser: PropTypes.object,
  userId: PropTypes.string,
  isLoading: PropTypes.bool,
  hasCheckedIfLoading: PropTypes.bool
};

class OwnerForm extends Component {
  render() {
    // let additionalOwner = _.get(this.additionalOwners, this.props.id, {dob:{},address:{}});
    let additionalOwner = this.props.additionalOwner;

    let firstName = _.get(additionalOwner, "firstName", "");
    let lastName = _.get(additionalOwner, "lastName", "");
    let day = _.get(additionalOwner, "dob.day", "");
    let month = _.get(additionalOwner, "dob.month", "");
    let year = _.get(additionalOwner, "dob.year", "");
    let addressLine1 = _.get(additionalOwner, "address.line1", "");
    let city = _.get(additionalOwner, "address.city", "");
    let state = _.get(additionalOwner, "address.state", "");

    return (
      <div className="additional-owner">
        <h5>Additional Owner #{this.props.id} (optional)</h5>
        <AvGroup row>
          <Label sm={3}>Legal name:</Label>
          <Col sm={4}>
            <AvField name={"owner" + this.props.id + "-firstName"} type="text" value={firstName} placeholder="First" onChange={this.props.handler} />
          </Col>
          <Col sm={4}>
            <AvField name={"owner" + this.props.id + "-lastName"} type="text" value={lastName} placeholder="Last" onChange={this.props.handler} />
          </Col>
        </AvGroup>

        <AvGroup row>
          <Label sm={3}>Date of birth:</Label>
          <Col sm={2}>
            <AvField name={"owner" + this.props.id + "-day"} type="text" value={day} maxLength="2" placeholder="Day" onChange={this.props.handler} />
          </Col>
          <Col sm={2}>
            <AvField name={"owner" + this.props.id + "-month"} type="text" value={month} maxLength="2" placeholder="Month" onChange={this.props.handler} />
          </Col>
          <Col sm={2}>
            <AvField name={"owner" + this.props.id + "-year"} type="text" value={year} maxLength="4" placeholder="Year" onChange={this.props.handler} />
          </Col>
        </AvGroup>

        <AvGroup row>
          <Label sm={3}>Address:</Label>
          <Col sm={8}>
            <AvField name={"owner" + this.props.id + "-line1"} type="text" value={addressLine1} placeholder="123 Pearse St" onChange={this.props.handler} />
          </Col>
          <Col sm={{ size: 4, offset: 3 }}>
            <AvField name={"owner" + this.props.id + "-city"} type="text" value={city} placeholder="City / town" onChange={this.props.handler} />
          </Col>
          <Col sm={{ size: 4, offset: 0 }}>
            <AvField name={"owner" + this.props.id + "-state"} type="select" value={state} onChange={this.props.handler}>
              <option value="">Please select a county</option>
              <option value="antrim">Antrim</option>
              <option value="armagh">Armagh</option>
              <option value="carlow">Carlow</option>
              <option value="cavan">Cavan</option>
              <option value="clare">Clare</option>
              <option value="clare">Cork</option>
              <option value="derry">Derry</option>
              <option value="donegal">Donegal</option>
              <option value="down">Down</option>
              <option value="dublin">Dublin</option>
              <option value="fermanagh">Fermanagh</option>
              <option value="galway">Galway</option>
              <option value="kerry">Kerry</option>
              <option value="kildare">Kildare</option>
              <option value="kilkenny">Kilkenny</option>
              <option value="laois">Laois</option>
              <option value="leitrim">Leitrim</option>
              <option value="limerick">Limerick</option>
              <option value="longford">Longford</option>
              <option value="louth">Louth</option>
              <option value="mayo">Mayo</option>
              <option value="meath">Meath</option>
              <option value="monaghan">Monaghan</option>
              <option value="offaly">Offaly</option>
              <option value="roscommon">Roscommon</option>
              <option value="sligo">Sligo</option>
              <option value="tipperary">Tipperary</option>
              <option value="tyrone">Tyrone</option>
              <option value="waterford">Waterford</option>
              <option value="westmeath">Westmeath</option>
              <option value="wexford">Wexford</option>
              <option value="wicklow">Wicklow</option>
            </AvField>
          </Col>
        </AvGroup>
      </div>
    );
  }
}

export default Merchant;
